<div mat-dialog-title>
  <div class="d-md-none my-3">
    <div class="d-flex justify-content-center">
      <div style="width: 79px;height: 5px; border-radius: 41px; background-color: #D9D9D9"></div>
    </div>
  </div>
  <div class="d-flex align-items-center">
    <img src="assets/imgs/icones/info-verde.svg" class="me-3">
    <span class="modal-title">Aceitar proposta</span>
  </div>
</div>

<div mat-dialog-content >
  <form [formGroup]="model.asForm" (ngSubmit)="enviar()">
    <div class="mt-3">
      <span class="text-black">Para prosseguirmos com a proposta, é necessário informações iniciais do credor</span>
    </div>
    <div class="form-group mb-3">
      <label for="nomeCredor"> Profissão </label>
      <input type="text" [ngClass]="{'is-invalid': !validarFormulario && model.form.controls.profissao.invalid}"  class="form-control" id="profissao" placeholder="Ex: Aposentado" formControlName="profissao">
      <div class="invalid-feedback">
        <span>Campo obrigatório</span>
      </div>
    </div>
    <div class="form-group mb-3">
      <label for="telefoneCredor">Telefone</label>
      <input type="text" class="form-control" [mask]="'(00) 0 0000-0000||(00) 0000-0000'"  id="telefoneCredor"
             [ngClass]="{'is-invalid': !validarFormulario && model.form.controls.telefoneCredor.invalid}"
             aria-describedby="telefoneCredor" placeholder="Ex: (00) 00000-0000"  formControlName="telefoneCredor">
      <div class="invalid-feedback">
        <span>Campo obrigatório</span>
      </div>
    </div>
    <div class="form-group mb-3">
      <label for="emailCredor">E-mail</label>
      <input type="text" class="form-control" id="emailCredor"
             [ngClass]="{'is-invalid': !validarFormulario && model.form.controls.emailCredor.invalid}"
             aria-describedby="emailCredor" placeholder="Ex: credor@email.com"  formControlName="emailCredor">
      <div class="invalid-feedback">
        <span>Campo obrigatório</span>
      </div>
    </div>
    <div class="form-group mb-3">
      <label for="observacao">Observações</label>
      <textarea type="text" class="form-control" id="observacao" aria-describedby="observacao" rows="3"
                [ngClass]="{'is-invalid': !validarFormulario && model.form.controls.observacaoCredor.invalid}"
                maxlength="299"
                formControlName="observacaoCredor"></textarea>
      <div class="invalid-feedback">
        <span>Campo obrigatório</span>
      </div>
      <div class="textarea-contador-wrapper">
        <span class="textarea-contador">{{ model.form.controls.observacaoCredor.value?.length || 0 }}/299</span>
      </div>
    </div>
    <div class="text-center">
      <div class="row">
        <div class="col-6">
          <button type="button" id="btnFecharDetalhes" class="btn btn-outline-secondary btn-sm w-100" (click)="fechar()">Voltar</button>
        </div>
        <div class="col-6">
          <button type="submit" id="btnCancelar" class="btn btn-primary btn-sm w-100">Aceitar proposta</button>
        </div>
      </div>
    </div>
  </form>
</div>

